export const getOnInfiniteScroll = (onScroll: (endReached: boolean) => void, margin = 0) => {
  return (event: React.SyntheticEvent) => {
    const listboxNode = event.currentTarget;
    if (
      Math.abs(Math.ceil(listboxNode.scrollTop + listboxNode.clientHeight) - Math.ceil(listboxNode.scrollHeight)) <=
      margin
    ) {
      onScroll(true);
    }
  };
};
